<template>
  <div
    @click="handleClick"
    :class="['table-caption', {isSort: column.sort, active: active}]"
    :style="columnStyle">
    {{ column.label }}
    <span v-if="column.sort" class="arrow" :class="classDirection">
    </span>
    <VCheckBox v-if="column.checkBox"
      ref="checkBox"
      :isCheckAll="true"
      :checkGroupValue="checkGroupValue"
      :indeterminate="indeterminate"
      @checkValue="handleCheckAll">
    </VCheckBox>
  </div>
</template>

<script>
import VCheckBox from './VCheckBox'
export default {
  name: 'v-th',
  components: {
    VCheckBox
  },
  props: {
    columnName: String,
    column: Object,
    active: {
      type: Boolean,
      default: false
    },
    sortDirection: {
      type: String,
      default: 'sort'
    },
    columnStyle: {
      type: Object,
      default: () => {
        return {}
      }
    },
    isCheckBox: {
      type: Boolean,
      default: false
    },
    checkGroupValue: {
      type: Array,
      default: () => []
    },
    tableData: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      checkAll: false,
      indeterminate: false
    }
  },
  computed: {
    classDirection () {
      return this.sortDirection === 'asc'
      ? 'table-caption-sort-asc'
      : this.sortDirection === 'desc'
      ? 'table-caption-sort-desc'
      : 'table-caption-sort'
    }
  },
  watch: {
    checkGroupValue (value) {
      // 检查body的选择框是否被选中，选中，则indeterminate为true
      this.indeterminate = value.length > 0 && value.length !== this.tableData.length
    }
  },
  methods: {
    handleClick () {
      if (this.column.sort) {
        const sortBy = [{
          name: this.columnName,
          sort: this.sortDirection === 'desc' ? 'asc' : 'desc'
        }]
        this.$emit('changeOrderBy', sortBy)
      }
    },
    handleCheckAll (value) {
      // 全选时候，存储所有值，否则，清空数组
      const checkAllList = value ? this.tableData.map(data => { return data.id }) : []
      this.$emit('changeCheckAll', checkAllList, value)
    }
  }
}
</script>

<style scoped lang="sass">
.table-caption
  line-height: 28px
  &.isSort
    cursor: pointer
    .arrow
      position: relative
      top: 3px
      margin-left: 5px
    &.active
      .arrow
        opacity: 1
</style>



// WEBPACK FOOTER //
// VTh.vue?75d55fde